<template>
  <v-dialog scrollable max-width="300px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <v-icon small :disabled="disabled" v-on="on" @click="init">edit</v-icon>
      </div>
    </template>
    <v-card>
      <v-card-title>
        <h4>PLDP</h4>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="validForm">

          <v-text-field
            label="porcentaje"
            v-model="parametros.porcentaje"
            :rules="[rules.required, rules.porcentaje]"
          >
          </v-text-field>

          <v-text-field
            label="segundosTocada"
            v-model="parametros.segundosTocada"
            :rules="[rules.required, rules.numero]"
          >
          </v-text-field>


        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
        <v-btn color="info" @click="confirmar" :disabled="!validForm">Actualizar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  props: ["disabled","regla"],
  data() {
    return {
      loading: false,
      showDialog: false,
      validForm: false,
      nuevoMonto: 0,
      rules: {
        required: (value) => !!value || "Requerido.",
        numero: (value) => {
          if (isNaN(value)) return false;
          if (+value) {
            return (
              (+value > 0 && +value <= 1000) || "Ingrese valor entre 1 y 1000"
            );
          }
          return true;
        },
        porcentaje: (value) => {
          if (value) {
            return (value > 0 && value <= 100) || "Ingrese valor entre 1 y 100";
          }
          return true;
        },
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
      },
      parametros: {
        porcentaje: null,
        segundosTocada: null
      },
    };
  },
  mounted() {

  },
  methods: {
    init() {

      this.parametros = {
        porcentaje: null,
        segundosTocada: null
      };

      this.regla.valores.forEach((v) => {
        if (v.nombre === "porcentaje") {
          this.parametros.porcentaje = v.valor;
        } else if (v.nombre === "segundosTocada") {
          this.parametros.segundosTocada = v.valor;
        }
      });
    },
    close() {
      this.showDialog = false;
    },
    volver() {
      this.showDialog = false;
    },
    confirmar() {
      // setTimeout(() => {
      //   this.$emit("nuevoMontoBolsa", {
      //     bolsaId: this.id,
      //     nuevoMontoBolsa: +this.nuevoMonto,
      //   });
      
      //this.close();
      // }, 500);

      
      const valores = [];
      for ( let key in this.parametros) {
        if (this.parametros[key]) {
          valores.push({nombre: key, valor: this.parametros[key]});
        }
      }      

      axios
        .post(
          `/regla/${this.regla.id}/actualizarParametros/`,
          valores
        )
        .then((response) => {
          console.log(response);
          this.$emit('actualizado', response.data)
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          this.nuevaCedula = this.cedula;
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
  },
});
</script>